import React, { useEffect, useState } from 'react';
import './OrderDetail.css';
import { useParams } from 'react-router-dom';
import Header from '../../Components/Header/Header';
import { APIKEY, BASE_URL, GET_ORDER_BY_ID } from '../../api';
import axios from 'axios';
import NotFoundImg from '../../Assets/images/no-image.png'

import cancelledStamp from "../../Assets/images/cancelled_stamp.png";
import paidStamp from "../../Assets/images/paid_stamp.png";
import unpaidStamp from "../../Assets/images/unpaid_stamp.png";
import voidStamp from "../../Assets/images/void_stamp.png";
import Loader from '../../Components/Loader/Loader';

const OrderDetail = () => {
    const { id } = useParams();
    const [orderData, setOrderData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchOrder = async () => {
        try {
            const response = await axios.get(GET_ORDER_BY_ID, {
                headers: {
                    "Content-Type": "application/json",
                    "API-Key": APIKEY,
                },
                params: {
                    order_id: id,
                },
            });

            if (response.data.status === 1) {
                setOrderData(response.data.data);
            } else {
                setError("Invalid response from server.");
            }
        } catch (err) {
            setError("Failed to fetch order.");
            console.error("Error fetching order detail:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrder();
    }, [id]);


    let backgroundImage;
    switch (orderData?.order?.payment_status) {
        case "paid":
            backgroundImage = `url(${paidStamp})`;
            break;
        case "pending":
            backgroundImage = `url(${unpaidStamp})`;
            break;
        case "voided":
            backgroundImage = `url(${voidStamp})`;
            break;
        case "refunded":
            backgroundImage = `url(${cancelledStamp})`;
            break;
        default:
            backgroundImage = "none";
    }


    if (loading) {
        return (
            <div className="order-detail-page">
                <Header />
                <div className="container text-center py-5">
                    <Loader />
                </div>
            </div>
        );
    }

    if (error || !orderData) {
        return (
            <div className="order-detail-page">
                <Header />
                <div className="container d-flex flex-column align-items-center justify-content-center mt-5 py-5">
                    <div className="error-box text-center p-4 rounded ">
                        <i className="fa-solid fa-triangle-exclamation fa-3x text-muted mb-3"></i>
                        <h4 className="mb-2 text-muted">Oops! Something went wrong.</h4>
                        <p className="text-muted mb-3">
                            {"We couldn't find the order you're looking for. Please double-check the order ID or try again later."}
                        </p>
                    </div>
                </div>
            </div>
        );
    }


    const order = orderData.order;
    const shipping = orderData.shipping_detail?.[0];
    const item = orderData.all_items?.[0];

    return (
        <>
            {loading && (<Loader />)}
            <div className="order-detail-page">
                <Header />
                <div className="container order-container">
                    <div className="row">
                        <div
                            className="col-md-8"

                        >
                            <div className="d-flex gap-2 align-items-center justify-content-start mb-2">
                                <div className="tick">
                                    <i className="fa-solid fa-circle-check"></i>
                                </div>
                                <div>
                                    <p className='mb-0 small'>Order #{order.order_id}</p>
                                    <h5 className='mb-0'>Thank you, {order.customer.first_name}!</h5>
                                    <p className='small text-muted'>
                                        {new Date(order.order_date).toLocaleDateString('en-US', {
                                            weekday: 'long',
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        })}
                                    </p>
                                </div>
                            </div>

                            <div className="row rounded py-3 px-2 info-box border mx-2 mt-4"
                                style={{
                                    background: `linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), ${backgroundImage} center/contain no-repeat`,
                                }}
                            >
                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <h6>Customer Information</h6>
                                        <p className='text-capitalize'>{order.customer.first_name} {order.customer.last_name}</p>
                                        <p>{order.customer.phone}</p>
                                        {order.customer.email && (<p>{order.customer.email || '-'}</p>)}
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <h6>Shipping Address</h6>
                                        {order.shipping_address?.reciever_name ||
                                            order.shipping_address?.address1 ||
                                            order.shipping_address?.city ? (
                                            <>
                                                <p>{order.shipping_address.reciever_name || 'Name not provided'}</p>
                                                <p>{order.shipping_address.address1 || 'Address not provided'}</p>
                                                <p>
                                                    {(order.shipping_address.city || '—')}, {(order.shipping_address.state || '—')}
                                                </p>
                                                <p>
                                                    {order.shipping_address.country || '—'} - {order.shipping_address.pincode || '—'}
                                                </p>
                                            </>
                                        ) : (
                                            <p className="text-muted">Shipping address not provided yet.</p>
                                        )}

                                    </div>
                                    <div className="col-md-6 mt-2 mt-md-0">
                                        <h6>Shipping Tracking</h6>
                                        {shipping?.courier_name ||
                                            shipping?.tracking_number ||
                                            shipping?.shipping_method ||
                                            shipping?.current_status ? (
                                            <>
                                                <p><strong>Courier:</strong> {shipping?.courier_name || 'Not provided yet'}</p>
                                                <p><strong>Tracking:</strong> {shipping?.tracking_number || 'Not available'}</p>
                                                <p><strong>Service:</strong> {shipping?.shipping_method || 'Not selected'}</p>
                                                <p><strong>Status:</strong> <span className="text-muted">{shipping?.current_status || 'Pending'}</span></p>
                                            </>
                                        ) : (
                                            <p className="text-muted">Shipping details not available yet.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 border-start-sm">
                            <div className="section">
                                <h3>Product</h3>
                                {orderData.all_items.map((item) => (
                                    <div key={item.id} className="product-item">
                                        <img
                                            src={
                                                item.image_url
                                                    ? item.image_url
                                                    : item.image_path
                                                        ? `${BASE_URL}${item.image_path}`
                                                        : NotFoundImg
                                            }
                                            onError={(e) => (e.target.src = NotFoundImg)}
                                            alt={item.product_name}
                                        />
                                        <div>
                                            <p><strong>{item.product_name}</strong></p>
                                            <p>{item.quantity} x ₹{item.price.toLocaleString()}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="section">
                                <div className="price-breakup">
                                    <hr />
                                    <div><span>Subtotal</span><span>₹{order.total_subtotal?.toFixed(2)}</span></div>
                                    <div><span>Discount (–)</span><span>₹{order.total_discounts?.toFixed(2)}</span></div>
                                    <div><span>Shipping</span><span>₹{order.shipping_charge?.toFixed(2)}</span></div>
                                    <hr />
                                    <div className="grand-total">
                                        <span><strong>Total</strong></span>
                                        <span className="text-danger"><strong>{orderData.formated_amount}</strong></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row">
                        <div className="col-md-10 mx-auto text-center mt-1">
                            <div className=" rounded d-flex align-items-start gap-3 justify-content-center">

                                <div className="text-center">
                                    <p className="mb-1 fw-semibold">Any Questions?</p>
                                    <p className="mb-0 small text-muted">
                                        If you need any assistance or support, feel free to call or WhatsApp us at{' '}
                                        <br />
                                        <a href="https://wa.me/917011969546" target="_blank" rel="noopener noreferrer" className="text-primary fw-semibold">
                                            Call or WhatsApp us at 7011969546
                                        </a>
                                    </p>
                                </div>
                            </div>

                            <div className="social-media-icons my-3">
                                <a href="https://www.facebook.com/partsklik" target="_blank" rel="noopener noreferrer" className="facebook"><i className="fab fa-facebook-f"></i></a>
                                {/* <a href="https://in.pinterest.com/partsklik" target="_blank" rel="noopener noreferrer" className="pinterest"><i className="fab fa-pinterest-p"></i></a> */}
                                <a href="https://www.instagram.com/partsklik" target="_blank" rel="noopener noreferrer" className="instagram"><i className="fab fa-instagram"></i></a>
                                {/* <a href="https://x.com/partsklik" target="_blank" rel="noopener noreferrer" className="twitter"><i className="fab fa-x-twitter"></i></a> */}
                                <a href="https://www.youtube.com/@TurboWale" target="_blank" rel="noopener noreferrer" className="youtube"><i className="fab fa-youtube"></i></a>
                                <a href="https://www.linkedin.com/company/partsklik-llp/" target="_blank" rel="noopener noreferrer" className="linkedin"><i className="fab fa-linkedin-in"></i></a>
                            </div>

                        </div>
                    </div>
                </div>


            </div>
        </>
    );
};

export default OrderDetail;
